import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { PrintOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../../app/hooks';
import { SaveAssetButton } from '../actions';
import GoBackButton from '../../../../common/components/styled-ui-elements/GoBackButton';

/**
 * AssetEditHeader - Professional header section for asset editing
 * Contains title, description, and action buttons
 */
export const AssetEditHeader: React.FC = () => {
  const navigate = useNavigate();
  const currentAsset = useAppSelector((state) => state.asset.currentAsset);

  const printLabel = () => {
    if (!currentAsset) return;
    const asset = { id: currentAsset.id, assetTag: currentAsset.assetTag, name: currentAsset.name };
    navigate('/assets/print-labels', { state: { assets: [asset] } });
  };

  return (
    <Box
      sx={{
        backgroundColor: '#ffffff',
        borderBottom: '2px solid #3b82f6',
        p: 2.5,
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography
            variant="h5"
            component="h1"
            fontWeight={600}
            color="#1e293b"
            sx={{ mb: 0.5 }}
          >
            Edit Asset
          </Typography>
          <Typography
            variant="body2"
            color="#64748b"
            sx={{ fontSize: '0.9rem' }}
          >
            Update asset details and maintenance schedule
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={2}>
          <Button
            variant="outlined"
            startIcon={<PrintOutlined />}
            onClick={printLabel}
            disabled={!currentAsset?.id}
          >
            Print Label
          </Button>
          <SaveAssetButton label="Save Changes" successMessage="Asset updated successfully!" />
          <GoBackButton />
        </Box>
      </Box>
    </Box>
  );
};

export default AssetEditHeader;
